// src/stores/media.js
import { writable } from 'svelte/store';

const { subscribe, set } = writable(false);

const updateMedia = () => {
  set(window.innerWidth < 768); // Adjust the breakpoint as needed
};

const initMedia = () => {
  updateMedia();
  window.addEventListener('resize', updateMedia);
};

initMedia();

export const isMobileStore = { subscribe };
